import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Invoice from '@spike/invoice-model';
import { Order } from '@spike/order-model';
import ResumeLine from 'components/Checkout2/UI/ResumeLine';
import TotalResumeLine from 'components/Checkout2/UI/TotalResumeLine';
import { formatAmount } from 'components/Checkout2/utils/OrderUtils';
import { FunctionComponent, useMemo } from 'react';

export interface OrderSubtotalResumeProps {
    invoice?: Invoice;
    order?: Order;
    loadingInvoice: boolean;
    loadingOrder: boolean;
    cancelledStatus: Array<AppointmentStatus>;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        resumeLine: {
            marginBottom: 12,
            [theme.breakpoints.down('sm')]: {
                marginBottom: 10
            }
        }
    })
);

export const OrderSubtotalResume: FunctionComponent<OrderSubtotalResumeProps> = props => {
    const classes = useStyles(props);

    const subtotal = useMemo(() => Number(props.order?.total ?? 0).toFixed(2), [props.order]);

    const totalMinutes = useMemo(
        () =>
            props.order?.items.appointments
                .filter(item => !props.cancelledStatus.includes(item.appointment.status.id))
                .map(item => item.appointment.duration)
                .map(duration => duration.to.clone().diff(duration.from.clone(), 'minutes'))
                .reduce((total, minutes) => total + minutes, 0) ?? 0,
        [props.order]
    );

    const duration =
        totalMinutes < 60 ? `${totalMinutes} min` : `${Math.trunc(totalMinutes / 60)} hr ${totalMinutes % 60} min`;

    return (
        <>
            <ResumeLine
                description="Deposit"
                value={formatAmount(props.invoice?.deposits.total ?? '0.00')}
                loading={props.loadingInvoice}
                className={classes.resumeLine}
            />
            <TotalResumeLine
                description="Subtotal"
                value={`$${subtotal} (${duration})`}
                loading={props.loadingOrder}
                className={classes.resumeLine}
            />
        </>
    );
};

export default OrderSubtotalResume;
